import axios from 'axios';

export const stagingUrl = 'https://lasrra-apis.touchandpay.me/';
const productionUrl = 'https://lapigw.azurewebsites.net/';

const ovrBaseUrl = process.env.REACT_APP_BASE_URL;
const envBaseUrl =
  process.env.NODE_ENV === 'development' ? stagingUrl : productionUrl;
export const baseUrl = ovrBaseUrl ?? envBaseUrl;

const axiosInstance = axios.create({
  baseURL: baseUrl
});

axiosInstance.interceptors.request.use(async (config) => {
  const token = sessionStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

export default axiosInstance;
